import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vw5fsq3bp4: FaireBrandEntity = {
  token: "b_vw5fsq3bp4",
  type: "brand",
  name: "Mahjong Studios",
  avatarUrl:
    "https://cdn.faire.com/fastly/20b2150d98e50bd43618939b12a62dd58182034ca62b79335c1efab6c643534b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f4300c3881419342530cfabec3cdd1b6c5c877f2f3b5e5841cbf7bd187b5b6de.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/20b2150d98e50bd43618939b12a62dd58182034ca62b79335c1efab6c643534b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f4300c3881419342530cfabec3cdd1b6c5c877f2f3b5e5841cbf7bd187b5b6de.jpeg",
  location: "Plano, TX, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 16,
  isTopShop: true,
  isInsider: true,
  description:
    "At Mahjong Studios, we make beautiful, lasting sets that help people slow down and come together. The steady click of tiles and the clean, familiar patterns invite calm focus—screen-free time that eases the mind. Designed for comfort and clarity, our pieces feel good in the hand and make it easy to play for hours with family and friends. Across generations and around any table, mahjong becomes a reason to connect, teach, laugh, and linger. We craft the tools; you make the memories—one hand at a time.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:13.548Z",
    importedBy: "entity-db-cli",
  },
};
